<template>
  <div>
    <portal to="modal-title">
      <cliente :cliente_id="cliente_id" @setCliente="setCliente" />
    </portal>
    <b-card no-body>     
      <b-tabs v-model="tabIndexMain" card active-nav-item-class="font-weight-bold">
        <b-tab :active="currentCartao.arquivado == 0" lazy title="ATIVOS"
          v-if="cliente_documento && cartoes.length > 0">
          <b-tabs v-model="tabIndex" card active-nav-item-class="font-weight-bold">
            <b-tab :active="cartao.tarefa_id == tarefa_id" v-for="(cartao, cartaoIndex) in cartoesAtivos"
              :key="cartaoIndex" lazy>
              <template #title>
                <span v-b-tooltip.hover :title="cartao.titulo" v-if="!!cartao.titulo && cartao.titulo.length >= 14">
                  {{ cartaoIndex == tabIndex ? cartao.titulo.substring(0, 30) + ((cartao.titulo.length) > 30 ? "..." :
                      "")
                      :
                      cartao.titulo.substring(0, 14) + "..."
                  }}
                </span>
                <span v-b-tooltip.hover :title="cartao.titulo" v-else>
                  {{ cartao.titulo }}
                </span>
              </template>
              <Cartao :tarefa_id="cartao.tarefa_id" @reloadCartoes="reloadCartoes" />
            </b-tab>

          </b-tabs>
        </b-tab>
        <b-tab :active="currentCartao.arquivado == 1" lazy title="ARQUIVADOS"
          v-if="cliente_documento && cartoes.length > 0">
          <b-tabs v-model="tabIndexArquivado" card active-nav-item-class="font-weight-bold">
            <b-tab :active="cartao.tarefa_id == tarefa_id" v-for="(cartao, cartaoIndex) in cartoesArquivados"
              :key="cartaoIndex" lazy>
              <template #title>
                <span v-b-tooltip.hover :title="cartao.titulo" v-if="!!cartao.titulo && cartao.titulo.length >= 14">
                  {{ cartaoIndex == tabIndexArquivado ? cartao.titulo.substring(0, 30) + ((cartao.titulo.length) > 30 ?
                      "..." :
                      "")
                      :
                      cartao.titulo.substring(0, 14) + "..."
                  }}
                </span>
                <span v-b-tooltip.hover :title="cartao.titulo" v-else>
                  {{ cartao.titulo }}
                </span>
              </template>
              <Cartao :tarefa_id="cartao.tarefa_id" />
            </b-tab>

          </b-tabs>
        </b-tab>
        <b-tab lazy title="TODOS OS ANEXOS" v-if="cliente_documento && cartoes.length > 0">
          <anexos :cliente_documento="cliente_documento"  @reloadCartoes="reloadCartoes" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
//import Anexos from "../sistema/Anexos.vue";

import Cartao from "./imports/Cartao.vue";

import { mapMutations } from "vuex";

export default {
  components: { Cartao },
  props: {
    cliente_id: { type: Number, required: true },
    tarefa_id: { type: Number, required: true },
    processo_id: { type: Number },
  },
  data() {
    return {
      modalShow: true,
      tabIndex: 0,
      tabIndexMain: 0,
      tabIndexArquivado: 0,
      cliente: {},
      cliente_documento: null,
      cartoes: [],
    };
  },
  computed: {
    currentCartao() {
      let result = this.cartoes.filter((item) => item.tarefa_id == this.tarefa_id);

      if (result.length > 0) {
        this.tabIndexMain = 0;

        if (result[0].arquivado == 1)
         this.tabIndexMain = 1 

        return result[0];

      }
      return [];
    },
    cartoesAtivos() {
      return this.cartoes.filter((item) => item.arquivado == 0);
    },
    cartoesArquivados() {
      return this.cartoes.filter((item) => item.arquivado == 1);
    }

  },
  created() {

    this.getCartoes();   

    

    this.setSize("xl");
  },
  methods: {
    ...mapMutations("modal_route", ["setSize"]),

    setCliente(cliente) {
      this.cliente_documento = cliente.cliente_documento;
    },
    async getCartoes() {
      let processo_id = "";
      if (this.processo_id)
        processo_id = { processo_id: this.processo_id };

      /*  if (this.$route.query.arquivado && !param_arquivado) {
          param_arquivado = true;
          arquivados = 1;
        } */

      const result = await this.$api.get(
        `tarefa/cartoes/${this.cliente_id}`,
        {
          params: processo_id,
        }
      );
      if (result && result.data) this.cartoes = result.data;


    },

    reloadCartoes(){    
       
      this.getCartoes();
    }
  },
};
</script>


<style lang="css" scoped>
.modal .upload-btn-wrapper input[type="file"] {
  width: 100% !important;
}

.tarefa-label {
  font-size: 16px;
}

.form-control:focus {
  border-color: #66afe9 !important;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6) !important;
}

.modal .btn-tarefa {
  background-color: rgba(9, 30, 66, 0.04);
}

.modal-content {
  background-color: #f4f5f7;
}

textarea {
  width: 100%;
  box-sizing: border-box;
  resize: none;
}

/* .btn-descricao {
        <?php if (!empty($tarefa->descricao)) : ?>display: none;
        <?php endif; ?>
    } */

.descricao p {
  color: #73879c;
}

.trumbowyg-editor,
.trumbowyg-textarea {
  position: relative;
  box-sizing: border-box;
  padding: 20px;
  min-height: 300px;
  width: 100%;
  border-style: none;
  resize: none;
  outline: 0;
  overflow: auto;
}

.trumbowyg-editor {
  background-color: white;
  color: #73879c;
}

.trumbowyg-editor,
.trumbowyg-textarea {
  min-height: auto;
}

.trumbowyg-box {
  height: auto;
  min-height: auto;
  margin: auto;
  flex: 1;
  /* <?php if (!empty($tarefa->descricao)) : ?>display: none;
        <?php endif; ?> */
}
</style>